import React from "react";
import { Container, Col } from "react-bootstrap";

const fixed = {
  backgroundImage: `url('https://res.cloudinary.com/universitytix/image/upload/v1600942280/VC_h3fg11.png')`,
};
function Research() {
  return (
    <div>

<div id="resources" className="offset">
        <div className="fixed-background">
          <div className="row dark text-center ">
            <Col sm="12">
              <br />
              <br />
              <br />
              <br />
              <br />
              <h3 className="heading headers">Research grants obtained</h3>

              <br />
              <br />
              <br />
              <br />
              <div className="heading-underline"></div>
            </Col>
          </div>

          <div className="fixed-wrap">
            <div className="fixed" style={fixed}></div>
          </div>
        </div>
      </div>

      <Container>
        <br />
        <br />
        <br />
        <li>
          TETFund Research Grant of N3.6m to conduct research on Radiological
          Investigation of the Bitumen Deposit in Agbabu area of Ondo State in
          conjunction with Prof. Aboluwoye and others (2012)
        </li>
        <br />
        <br />
        <li>
          Adekunle Ajasin University, Akungba-Akoko Research Grant of
          N1,400,000.00 to conduct research on Concentration and Vertical
          Distribution of Cs-137 in the Soil of South West Nigeria( 2009)
        </li>
        <br />
        <br />
        <li>
          National Space Research and Development Agency (NASRDA), Abuja,
          N17.45m Grant to conduct research on Sustainable Optimum Cocoa
          Production in Ondo State Using Remote Sensing and GIS (2008) – A high
          tech laboratory was equipped for the project in the University
        </li>
        <br />
        <br />
        <li>
          Grant in form of donation of a solar-powered weather station equipment
          worth several millions to participate in the Nigeria Environmental and
          Climatic Observation Programme (NECOP) – A global research network of
          the atmospheric and climatic data generation for research purposes
          (2006) – equipment donated by Centre for Basic Space Science (CBSS),
          Nsukka under the Federal Ministry of Science and Technology, Abuja
        </li>
        <br />
        <br />
        <li>
          Adekunle Ajasin University, Akungba-Akoko Research Grant of N80,000.00
          to conduct research on Terrestrial Gamma Dose Rates in Akoko South
          West, Nigeria, (2005)
        </li>
      </Container>
    </div>
  );
}
export default Research;
